// services/atualizarEmpreendimento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
// --------------------- Import Interface ---------------------
import { Empreendimento } from "../interfaces/Empreendimento";

export const cadastrarEmpreendimentoService = async (
  valuesEmp: Empreendimento
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/empreendimento/${valuesEmp.cidadeId}`;
    try {
      const response = await axios.post(URL, valuesEmp, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};
